import { default as Constants } from 'expo-constants'

export const getExportedEnv = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const Constants = require('expo-constants').default
    return Constants.expoConfig?.extra
  } catch (error) {
    return {}
  }
}
